import { createAction, props } from '@ngrx/store';

export const detectDevice = createAction('[Device] Detect Device');

export const setIsMobile = createAction(
  '[Device] Set Is Mobile',
  props<{ isMobile: boolean }>(),
);
